import React, { useEffect, useRef } from "react";
import useState from "react-usestateref";
import Header from "../Header";
import { Link, useNavigate } from "react-router-dom";
import CalendarView from "../Views/CalendarView";
import { useSelector, useDispatch } from "react-redux";
import {
  actionGetDashboard,
  actionSetDashboard,
  actionSetRolesDashboard,
  actionUpdateDashboard,
  actionDeleteDashboard,
  actionChangeTime,
  removeUserDashboard,
  actionSetUserRoleDashboard,
  actionSetTeamRoleDashboard,
  removeTeamDashboard,
  actionGetDashboardsByUser,
} from "../../redux/actions/dashboardAction";
import {
  actionCreateIndicators,
  actionGetIndicatorsByDataSource,
} from "../../redux/actions/IndicatorsAction";
import {
  actionSetTime,
  actionSetTimeValue,
} from "../../redux/actions/timeAction";
import Popover from "@mui/material/Popover";
import { EditText } from "react-edit-text";
import Modal from "../Views/Modal";
import Avatar from "antd/lib/avatar/avatar";
import stc from "string-to-color";
import CustomSelect from "../Views/CustomSelect";
import ModalAddSource from "../Views/ModalAddSource";
import { isInteger, parseInt, unionBy } from "lodash";
import {
  actionAddDatasource,
  actionSetDataDatasources,
} from "../../redux/actions/datasourceAction";
import {
  actionAddIndicator,
  actionSetIndicatorData,
  actionGetDataByFilter,
} from "../../redux/actions/indicatorAction";
import { actionGetConnectors } from "../../redux/actions/connectorAction";
import { actionGetDatasources } from "../../redux/actions/datasourceAction";
import ModalShared from "../Views/ModalShared";
import Snackbar from "@mui/material/Snackbar";
import CircularProgress from "@mui/material/CircularProgress";
import Paper from "@mui/material/Paper";
import Alert from "@mui/material/Alert";
import moment from "moment";
import { Tooltip, Checkbox, Popover as PopoverAntd } from "antd";
import Select from "react-select";
import { useSnackbar } from "notistack";
import RadioButton from "../Views/RadioButton";
import useReceive from "../DataSource/useReceive";
import useCheck from "../DataSource/useCheck";
import ModalPrint from "../Views/ModalPrint";
import TrelloDashboard from "./TrelloDashboard";
import SimpleDashboard from "./SimpleDashboard";
import Member from "../Views/Member";
import { useSocket } from "../../context/socketContext";
import { actionGetConditionByDdataSource } from "../../redux/actions/ConditionAction";
import {
  actionAddList,
  actionDeleteList,
  actionMoveLists,
  actionSetLists,
  actionUpdateList,
} from "../../redux/actions/listAction";
import ViewContainer from "../Views/ViewContainer";

let theme = "1";
const data = localStorage.getItem("theme");

if (data) {
  theme = JSON.parse(data).theme;
}

export const getIntervalByValue = (value) => {
  if (value !== "0") {
    let a = moment();
    let b = moment();
    switch (value) {
      case "1":
        a.hours(0);
        b.hours(23);

        a.minutes(0);
        b.minutes(59);

        a.seconds(0);
        b.seconds(0);

        a.milliseconds(0);
        b.milliseconds(0);

        break;

      case "2":
        a.hours(0);
        b.hours(23);

        a.minutes(0);
        b.minutes(59);

        a.seconds(0);
        b.seconds(59);

        a.milliseconds(0);
        b.milliseconds(0);

        a.weekday(0);
        b.weekday(7);

        break;

      case "3":
        a.hours(0);
        b.hours(23);

        a.minutes(0);
        b.minutes(59);

        a.seconds(0);
        b.seconds(59);

        a.milliseconds(0);
        b.milliseconds(0);

        a.date(1);
        b.date(1);

        b.month(b.month() + 1);

        break;

      case "4":
        a.hours(0);
        b.hours(23);

        a.minutes(0);
        b.minutes(59);

        a.seconds(0);
        b.seconds(59);

        a.milliseconds(0);
        b.milliseconds(0);

        a.date(1);
        b.date(1);
        a.month(a.month() - 2);
        b.month(b.month() + 1);

        break;

      case "5":
        a.hours(0);
        b.hours(23);

        a.minutes(0);
        b.minutes(59);

        a.seconds(0);
        b.seconds(59);

        a.milliseconds(0);
        b.milliseconds(0);

        a.date(1);
        b.date(1);
        a.month(a.month() - 5);
        b.month(b.month() + 1);

        break;

      case "6":
        a.hours(0);
        b.hours(23);

        a.minutes(0);
        b.minutes(59);

        a.seconds(0);
        b.seconds(59);

        a.milliseconds(0);
        b.milliseconds(0);

        a.date(1);
        b.date(1);

        a.month(0);
        b.month(0);

        a.month(0);
        b.year(b.year() + 1);

        break;
      default:
        return [null, null];
    }
    return [a, b];
  } else {
    return [null, null];
  }
};

export default function Board() {
  const { enqueueSnackbar } = useSnackbar();
  const [frequence, setFrequence, frequenceRef] = useState(1);
  const [filters, setFilters, filtersRef] = useState([]);
  const [screenX, setScreenX] = useState(window.innerWidth);
  const [trelloY, setTrelloY] = useState(window.screen.height - 270);
  const [simpleY, setSimpleY] = useState(window.screen.height - 270);

  let navigate = useNavigate();
  const dispatch = useDispatch();

  const pourcent = useSelector((state) => state.datasource.pourcent);
  const visibilityProgress = useSelector(
    (state) => state.datasource.visibilityProgress
  );

  // dashboard
  const dashboards = useSelector((state) => state.board.dashboards);
  const role = useSelector((state) => state.user.role);
  const iscapable = ["ADMIN", "OWNER"].includes(role);
  // board state ---->
  const board = useSelector((state) => state.board.dashboard);
  const indicateurData = useSelector((state) => state.indicators.indicators);
  const selectedWorkSpace = useSelector(
    (state) => state.user.selectedWorkSpace
  );

  const manager = useSelector((state) => state.board.manager);
  const managerRef = useRef();
  managerRef.current = manager;
  const isDeleteBoard = useSelector((state) => state.board.isDelete);
  const isViewOnly = useSelector((state) => state.board.isViewOnly);
  const isOwner = useSelector((state) => state.board.isOwner);
  // <-----------

  // list state ---->
  const lists = useSelector((state) => state.list.lists);
  const isDelete = useSelector((state) => state.list.isDelete);
  const listsRef = useRef();
  listsRef.current = lists;
  // <-----------

  // user state ---->
  const token = useSelector((state) => state.user.token);
  const idUser = useSelector((state) => state.user.id);
  const userEmail = useSelector((state) => state.user.email);
  const isAddList = useSelector((state) => state.list.isAdd);
  const isUpdate = useSelector((state) => state.list.isUpdate);
  // console.log(teams);
  // <-----------

  // datasource state ---->
  const [idconnector, setIdConnector, idConnectorRef] = useState(null);
  const [url, setUrl, urlRef] = useState(null);
  const datasources = useSelector((state) => state.datasource.datasources);

  const conditions = useSelector((state) => state.condition.conditions);
  const optionsConditions = conditions.map((item) => ({
    label: item.name,
    value: item.id,
  }));
  const datasourcesRef = useRef();
  datasourcesRef.current = datasources;
  const [refresh, setRefresh, refreshRef] = useState({
    value: false,
    label: "Manuel",
  });
  const [period, setPeriod, periodRef] = useState({
    value: 0,
    label: "Heure",
  });
  const [idperiod, setIdPeriod] = useState(null);
  const [externalIds, setExternalIds] = useState(null);
  const operationOptions = [
    { value: 1, label: "Remplacer les données." },
    { value: 2, label: "Ajouter les données." },
    { value: 3, label: "Ajout intelligent des données." },
  ];

  const GRAPH_TYPES = [
    { value: "0", label: "Bar Graph vertical" },
    { value: "1", label: "Linear Graph" },
    { value: "2", label: "Pie Graph" },
    { value: "3", label: "Coordonnées Géographiques" },
    { value: "4", label: "Table" },
    { value: "5", label: "Calendar" },
    { value: "6", label: "Bar Graph horizontal" },
    // { value: "7", label: "Histogram" },
  ];

  const [data_operation, setData_operation, data_operationRef] = useState(
    operationOptions[0]
  );

  const [data, setData] = useReceive(url);
  useCheck();
  // <-----------

  // indicator state ---->
  const isAddIndicator = useSelector((state) => state.indicator.isAdd);
  const [description, setDescription, descriptionRef] = useState("");

  const formuleOptions = [
    { value: 1, label: "Somme" },
    { value: 2, label: "Moyenne" },
    { value: 3, label: "Aucun calcul" },
    { value: 4, label: "Compteur" },
  ];

  const [operation, setOperation, operationRef] = useState(formuleOptions[0]);
  const [size, setSize, sizeRef] = useState("1");
  const [symbole, setSymbole, symboleRef] = useState("");
  const [sourceName, setSourceName, sourceNameRef] = useState("");
  const [indicatorName, setIndicatorName, indicatorNameRef] = useState("");
  const [showRadioRegroupe, setShowRadioRegroupe, showRadioRegroupeRef] =
    useState(false);
  const [
    radioRegroupeDefault,
    setRadioRegroupeDefault,
    radioRegroupeDefaultRef,
  ] = useState("1");
  const [anchorEl, setAnchorEl] = useState(null);
  const [landa, setLanda] = useState("title-1");
  const [name, setName] = useState("");
  const [value, setValue, periodeRef] = useState("0");
  const [interval, setInterval, intervalRef] = useState([null, null]);
  const [modalSharedVisibility, setModalSharedVisibility] = useState(false);
  const [idlist, setIdlist, idListRef] = useState({});
  const [deleteVisibility, setDeleteVisibility] = useState(false);
  const [sourceVisibility, setSourceVisibility] = useState(false);
  const [iframeVisibility, setIframeVisibility] = useState(false);
  const [visibility, setVisibility] = useState(false);
  const [isAsync, setIsAsync] = useState(false);
  const [source, setSource, sourceRef] = useState(null);
  const [metrics, setMetrics, metricsRef] = useState([]);
  const [showLastValue, setShowLastValue] = useState(false);
  const [notShowCumulWithGoal, setNotShowCumulWithGoal] = useState(false);
  const [showCumul, setShowCumul] = useState(false);
  const [axeEmail, setAxeEmail, axeEmailRef] = useState(null);
  const [showByEmail, setShowByEmail, showByEmailRef] = useState(false);
  const [optionsAxeEmail, setOptionsAxeEmail] = useState([]);
  const [axeDate, setAxeDate, axeDateRef] = useState(null);
  const [axes, setAxes, axesRef] = useState(null);
  const [type, setType, typeRef] = useState(GRAPH_TYPES[0]);
  const [defaultAxe, setDefaultAxe, defaultAxeRef] = useState(null);
  const [selectedLists, setSelectedLists, selectedListsRef] = useState([]);
  const [optionsMetric, setOptionsMetric] = useState([]);
  const [optionsAxe, setOptionsAxe] = useState([]);
  const [optionsAxeDate, setOptionsAxeDate] = useState([]);
  const [optionsDatasources, setOptionsDatasources] = useState([]);
  const [color, setColor] = useState(theme === "0" ? "white" : "black");
  const [modifParam, setModifParam] = useState(false);
  const [selectedDashboard, setSelectedDashboard] = useState("");
  const [selectedTypes, setSelectedTypes] = useState([]);

  const { joinRoom, leaveRoom, listenDatasource } = useSocket();

  const [rules, setRules] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [condition, setCondition] = useState(null);
  const [target, setTarget] = useState({ value: 0, label: "en tête" });
  const [comp, setComp] = useState({ value: "0", label: "Apparence" });
  const [selectedColor, setSelectedColor] = useState("#000000");
  const [isBold, setIsBold] = useState(false);
  const [isItalic, setIsItalic] = useState(false);
  const [isUnderline, setIsUnderline] = useState(false);
  const [fontSize, setFontSize] = useState(14);
  const [editingId, setEditingId] = useState(null);
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [indicateurs, setIndicateurs] = useState([]);
  const [label, setLabel] = useState("");
  const [updateVisibility, setUpdateVisibility] = useState(false);
  const [listVisibility, setListVisibility] = useState(false);
  const [selectedList, setSelectedList] = useState(null);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [readonly, setReadOnly] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (editingId !== null) {
      setRules(
        rules.map((item) =>
          item.id === editingId
            ? {
                ...item,
                title,
                comp,
                condition,
                color: selectedColor,
                isBold,
                isItalic,
                isUnderline,
                fontSize,
                target,
              }
            : item
        )
      );
      setEditingId(null);
    } else {
      setRules([
        ...rules,
        {
          id: Date.now(),
          title,
          condition,
          comp,
          color: selectedColor,
          isBold,
          isItalic,
          isUnderline,
          fontSize,
          target,
        },
      ]);
    }
    handleCancel();
  };
  const handleCancel = (e) => {
    setTitle("");
    setComp({ value: "0", label: "Apparence" });
    setCondition(null);
    setTarget({ value: 0, label: "en tête" });
    // setRules([]);
    setSelectedColor("#000000");
    setIsBold(false);
    setIsItalic(false);
    setFontSize(14);
    setIsOpen(false);
    setEditingId(null);
    setVisibility(true);
    setIsUnderline(false);
  };

  const handleEdit = (item) => {
    setTitle(item.title);
    setComp(item.comp);
    setCondition(item.condition);
    setTarget(item.target);
    setSelectedColor(item.color);
    setIsBold(item.isBold);
    setIsItalic(item.isItalic);
    setIsUnderline(item.isUnderline);
    setFontSize(item.fontSize);
    setEditingId(item.id);
    setIsOpen(true);
  };

  const handleDelete = (id) => {
    setRules(rules.filter((item) => item.id !== id));
  };
  const fontSizes = [12, 14, 16, 18, 20, 24];

  const options = [];
  // <-----------

  const update = () => {
    setAnchorEl(null);
    let element = document.getElementById(
      `input-default-text-editable-selected`
    );
    let evObj = document.createEvent("Events");
    evObj.initEvent("click", true, false);
    element.dispatchEvent(evObj);
    setTimeout(() => {
      document.getElementById(`input-default-text-editable-selected`).focus();
    }, 250);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const getUniqueDataSourceIds = (data) => {
    // Crée un Set pour stocker les iddatasource uniques
    const uniqueIds = new Set();

    // Parcourt chaque liste
    data.forEach((list) => {
      // Parcourt chaque indicateur dans la liste
      list.indicators.forEach((indicator) => {
        // Ajout des iddatasource des colonnes
        indicator.columns.forEach((column) => {
          if (column.iddatasource) {
            uniqueIds.add(column.iddatasource);
          }
        });

        // Ajout des iddatasource des métriques
        indicator.metrics.forEach((metric) => {
          if (metric.iddatasource) {
            uniqueIds.add(metric.iddatasource);
          }
        });
      });
    });

    // Convertit le Set en array et le retourne
    return Array.from(uniqueIds);
  };

  const open = Boolean(anchorEl);
  const tag = open ? `simple-popover-selected` : undefined;

  const resize = () => {
    setScreenX(window.innerWidth);
    const x = document.getElementById("viabber-header").clientHeight;
    const x2 = document.getElementById("viabber-board-container").clientHeight;
    setTrelloY(document.documentElement.clientHeight - (x + x2 + 25));
    setSimpleY(document.documentElement.clientHeight - (x + x2 + 25));
  };

  useEffect(() => {
    if (data) {
      setIframeVisibility(false);
      setSourceVisibility(true);
    }
  }, [data]);

  useEffect(() => {
    const idworkspace = localStorage.getItem("idworkspace");
    if (idworkspace) {
      dispatch(
        actionGetDatasources(idworkspace, token, (result) => {
          console.log(result);
        })
      );
      dispatch(actionGetDashboardsByUser(idworkspace, token));
    }
  }, []);

  useEffect(() => {
    // Récupération des IDs de datasources uniques
    const iddatasources = getUniqueDataSourceIds(lists);

    // Rejoindre les rooms pour chaque datasource
    iddatasources.forEach((iddatasource) => {
      joinRoom(iddatasource.toString());
    });

    // Écouter les mises à jour des données
    listenDatasource((data) => {
      if (data && data.id) {
        // console.log(data);
        getNewData(data.id);
        // console.log("Updated data");
      }
    });

    // Nettoyage à la destruction du composant
    return () => {
      iddatasources.forEach((iddatasource) => {
        leaveRoom(iddatasource.toString());
      });
    };
  }, [lists]);

  useEffect(() => {
    window.addEventListener("resize", resize);
    resize();

    const today = new URL(window.location.href).searchParams.get("today");
    const lastWeek = new URL(window.location.href).searchParams.get("lastweek");

    if (today && lastWeek) {
      setInterval([
        moment(new Date(new Date(parseInt(lastWeek)).toISOString())),
        moment(new Date(new Date(parseInt(today)).toISOString())),
      ]);
      dispatch(
        actionSetTime([
          moment(new Date(new Date(parseInt(lastWeek)).toISOString())),
          moment(new Date(new Date(parseInt(today)).toISOString())),
        ])
      );
      dispatch(actionSetTimeValue("2"));
      setValue("2");

      dispatch(
        actionSetIndicatorData({
          interval: [
            moment(new Date(new Date(parseInt(lastWeek)).toISOString())),
            moment(new Date(new Date(parseInt(today)).toISOString())),
          ],
        })
      );
      const data = localStorage.getItem("data");
      const idworkspace = localStorage.getItem("idworkspace");
      const dashboard = sessionStorage.getItem("dashboard");
      const token = sessionStorage.getItem("token");
      console.log(idworkspace);
      if (!data && !dashboard && !token && !idworkspace) {
        navigate("/");
      } else if (!dashboard) {
        navigate("/home");
      } else if (data) {
        setName(JSON.parse(dashboard).name);
        dispatch(actionSetDashboard(JSON.parse(dashboard)));
        dispatch(
          actionGetDashboard(
            JSON.parse(dashboard).iddashboard,
            idUser,
            "Bearer " + JSON.parse(data).token,
            (status, response, userDashboards) => {
              if (status === 200) {
                let manager = null;
                for (let index = 0; index < userDashboards.length; index++) {
                  const element = userDashboards[index];
                  if (element.role === "OWNER") {
                    manager = element;
                    break;
                  }
                }
                for (let index = 0; index < userDashboards.length; index++) {
                  const element = userDashboards[index];
                  if (
                    parseInt(element.iduser) ===
                    parseInt(JSON.parse(data).userId)
                  ) {
                    if (element.interval) {
                    } else if (manager && manager.interval) {
                    }
                    break;
                  }
                }
                defaultData();
                setName(response.name);
                if (
                  parseInt(managerRef.current.id) ===
                  parseInt(JSON.parse(data).userId)
                ) {
                  dispatch(
                    actionSetRolesDashboard({
                      isViewOnly: false,
                      isOwner: true,
                    })
                  );
                } else {
                  for (
                    let index = 0;
                    index < response.userDashboards.length;
                    index++
                  ) {
                    const element = response.userDashboards[index];
                    if (
                      parseInt(element.iduser) ===
                      parseInt(JSON.parse(data).userId)
                    ) {
                      if (element.role === "OWNER") {
                        dispatch(
                          actionSetRolesDashboard({
                            isViewOnly: false,
                            isOwner: true,
                          })
                        );
                      } else if (element.role === "VIEW") {
                        dispatch(
                          actionSetRolesDashboard({
                            isViewOnly: true,
                            isOwner: false,
                          })
                        );
                      } else {
                        dispatch(
                          actionSetRolesDashboard({
                            isViewOnly: false,
                            isOwner: false,
                          })
                        );
                      }
                      break;
                    }
                  }
                }
              } else {
                alert("error");
              }
            }
          )
        );
        dispatch(actionGetConnectors("Bearer " + JSON.parse(data).token));
        dispatch(
          actionGetDatasources(
            idworkspace,
            "Bearer " + JSON.parse(data).token,
            (result) => {
              console.log(result);
            }
          )
        );
      } else {
        setName(JSON.parse(dashboard).name);
        dispatch(actionSetDashboard(JSON.parse(dashboard)));
        dispatch(
          actionGetDashboard(
            JSON.parse(dashboard).iddashboard,
            idUser,
            JSON.parse(token).token,
            (status, response, userDashboards) => {
              if (status === 200) {
                defaultData();
              } else {
                alert("error");
              }
            }
          )
        );
      }
      return;
      //////////////////////////////////////////////////////////////////////////
    } else {
      setInterval(getIntervalByValue("3"));
      dispatch(actionSetTime(getIntervalByValue("3")));
      dispatch(actionSetTimeValue("3"));
      setValue("3");
      dispatch(
        actionSetIndicatorData({
          interval: getIntervalByValue("3"),
        })
      );

      const data = localStorage.getItem("data");
      const dashboard = sessionStorage.getItem("dashboard");
      const token = sessionStorage.getItem("token");
      const idworkspace = localStorage.getItem("idworkspace");
      if (!data && !dashboard && !token && !idworkspace) {
        navigate("/");
      } else if (!dashboard) {
        navigate("/home");
      } else if (data) {
        setName(JSON.parse(dashboard).name);
        dispatch(actionSetDashboard(JSON.parse(dashboard)));

        dispatch(
          actionGetDashboard(
            JSON.parse(dashboard).iddashboard,
            idUser,

            "Bearer " + JSON.parse(data).token,
            (status, response, userDashboards) => {
              if (status === 200) {
                let manager = null;
                for (let index = 0; index < userDashboards.length; index++) {
                  const element = userDashboards[index];
                  if (element.role === "OWNER") {
                    manager = element;
                    break;
                  }
                }
                for (let index = 0; index < userDashboards.length; index++) {
                  const element = userDashboards[index];
                  if (
                    parseInt(element.iduser) ===
                    parseInt(JSON.parse(data).userId)
                  ) {
                    if (element.interval) {
                      setInterval([
                        moment(new Date(element.datedebut)),
                        moment(new Date(element.datefin)),
                      ]);
                      setValue(element.interval);
                      dispatch(
                        actionSetTime([
                          moment(new Date(element.datedebut)),
                          moment(new Date(element.datefin)),
                        ])
                      );
                      dispatch(actionSetTimeValue(element.interval));
                      dispatch(
                        actionSetIndicatorData({
                          interval: [
                            moment(new Date(element.datedebut)),
                            moment(new Date(element.datefin)),
                          ],
                        })
                      );
                    } else if (manager && manager.interval) {
                      setInterval([
                        moment(new Date(manager.datedebut)),
                        moment(new Date(manager.datefin)),
                      ]);
                      setValue(manager.interval);
                      dispatch(
                        actionSetTime([
                          moment(new Date(manager.datedebut)),
                          moment(new Date(manager.datefin)),
                        ])
                      );
                      dispatch(actionSetTimeValue(manager.interval));
                      dispatch(
                        actionSetIndicatorData({
                          interval: [
                            moment(new Date(manager.datedebut)),
                            moment(new Date(manager.datefin)),
                          ],
                        })
                      );
                    }
                    break;
                  }
                }
                defaultData();
                setName(response.name);
                if (
                  parseInt(managerRef.current.id) ===
                  parseInt(JSON.parse(data).userId)
                ) {
                  dispatch(
                    actionSetRolesDashboard({
                      isViewOnly: false,
                      isOwner: true,
                    })
                  );
                } else {
                  for (
                    let index = 0;
                    index < response.userDashboards.length;
                    index++
                  ) {
                    const element = response.userDashboards[index];
                    if (
                      parseInt(element.iduser) ===
                      parseInt(JSON.parse(data).userId)
                    ) {
                      if (element.role === "OWNER") {
                        dispatch(
                          actionSetRolesDashboard({
                            isViewOnly: false,
                            isOwner: true,
                          })
                        );
                      } else if (element.role === "VIEW") {
                        dispatch(
                          actionSetRolesDashboard({
                            isViewOnly: true,
                            isOwner: false,
                          })
                        );
                      } else {
                        dispatch(
                          actionSetRolesDashboard({
                            isViewOnly: false,
                            isOwner: false,
                          })
                        );
                      }
                      break;
                    }
                  }
                }
              } else {
                alert("error");
              }
            }
          )
        );
        dispatch(actionGetConnectors("Bearer " + JSON.parse(data).token));
        dispatch(
          actionGetDatasources(
            idworkspace,
            "Bearer " + JSON.parse(data).token,
            (result) => {
              console.log(result);
            }
          )
        );
      } else {
        setName(JSON.parse(dashboard).name);
        dispatch(actionSetDashboard(JSON.parse(dashboard)));
        dispatch(
          actionGetDashboard(
            JSON.parse(dashboard).iddashboard,
            idUser,
            JSON.parse(token).token,
            (status, response, userDashboards) => {
              if (status === 200) {
                for (let index = 0; index < userDashboards.length; index++) {
                  const element = userDashboards[index];
                  if (element.role === "OWNER") {
                    if (element.interval) {
                      setInterval([
                        moment(new Date(element.datedebut)),
                        moment(new Date(element.datefin)),
                      ]);
                      setValue(element.interval);
                      dispatch(
                        actionSetTime([
                          moment(new Date(element.datedebut)),
                          moment(new Date(element.datefin)),
                        ])
                      );
                      dispatch(actionSetTimeValue(element.interval));
                      dispatch(
                        actionSetIndicatorData({
                          interval: [
                            moment(new Date(element.datedebut)),
                            moment(new Date(element.datefin)),
                          ],
                        })
                      );
                    }
                    break;
                  }
                }
                defaultData();
              } else {
                alert("error");
              }
            }
          )
        );
      }
    }
    return () => {
      window.removeEventListener("resize", resize);
    };
  }, [selectedDashboard]);

  useEffect(() => {
    let datasourcesArray = [];
    for (let i = 0; i < datasources.length; i++) {
      const element = datasources[i];

      datasourcesArray.push({ value: i, key: i, label: element.name });
    }

    setAxes(null);
    setSource(null);
    setMetrics(null);
    setAxeDate(null);
    setDefaultAxe(null);

    setOptionsAxeEmail([]);
    setOptionsAxe([]);
    setOptionsMetric([]);
    setOptionsAxeDate([]);
    setOptionsDatasources(datasourcesArray);
  }, [datasources]);

  const onAdd = (e) => {
    if (data_operation.value === 3) {
      if (Array.isArray(externalIds)) {
        for (let i = 0; i < externalIds.length; i++) {
          const column = externalIds[i];
          for (let j = 0; j < data.columns.length; j++) {
            if (data.columns[j].index === column.value) {
              data.columns[j].unique = true;
            }
          }
        }
      } else {
        enqueueSnackbar(
          "Veuillez sélectionner au moins un identifiant unique.",
          {
            variant: "warning",
          }
        );
      }
    }
    e.preventDefault();
    if (sourceNameRef.current) {
      dispatch(
        actionAddDatasource(
          idUser,
          idConnectorRef.current,
          {
            name: sourceNameRef.current,
            operation: data_operationRef.current.value,
            periode: refreshRef.current.value ? periodRef.current.value : 0,
            refreshed: Boolean(data.url) ? refreshRef.current.value : false,
            nbre: refreshRef.current.value ? frequenceRef.current : 1,
            url: data.url,
            rows: data.rows,
            columns: data.columns,
            callback: data.callback,
            isAsync: isAsync,
          },
          token,
          (status, datasource) => {
            if (status === 200) {
              setSourceVisibility(false);
              setVisibility(true);
              setData(null);
              dispatch(
                actionSetDataDatasources({
                  id: datasource.iddatasource,
                  visibilityProgress: true,
                })
              );
            } else {
              enqueueSnackbar(
                "Une erreur c'est produite lors de l'insertion.",
                { variant: "error" }
              );
            }
          }
        )
      );
    }
  };

  const cancelShared = () => {
    setModalSharedVisibility(false);
  };

  const defaultData = () => {
    for (let i = 0; i < listsRef?.current.length; i++) {
      const list = listsRef.current[i];
      for (let j = 0; j < list.indicators.length; j++) {
        const indicator = list.indicators[j];
        const id = parseInt(indicator.idindicator);
        let filter = null;
        let defaultAxe = null;
        let emailAxe = null;

        if (indicator.idEmailColumn && indicator.showByEmail) {
          for (let index = 0; index < indicator.columns.length; index++) {
            const column = indicator.columns[index];

            if (+column.idcolumn == +indicator.idEmailColumn) {
              emailAxe = column;
              break;
            }
          }
        }

        for (let index = 0; index < indicator.columns.length; index++) {
          const column = indicator.columns[index];
          if (column.idcolumn == indicator.idfilter) {
            filter = column;
            break;
          }
        }

        if (indicator.iddefault) {
          for (let index = 0; index < indicator.columns.length; index++) {
            const column = indicator.columns[index];
            if (column.idcolumn == indicator.iddefault) {
              defaultAxe = column;
              break;
            }
          }
        } else {
          defaultAxe = { ...filter };
        }

        const filters = [
          {
            name: filter.name,
            type: 3,
            class: "time",
            interval: [
              new Date(new Date(intervalRef.current[0]).setHours(21, 0, 0, 0))
                .toISOString()
                .split(".")[0],
              new Date(new Date(intervalRef.current[1]).setHours(21, 0, 0, 0))
                .toISOString()
                .split(".")[0],
            ],
          },
        ];

        if (emailAxe) {
          filters.push({
            name: emailAxe.name,
            type: 2,
            class: "dimensions",
            values: [userEmail],
          });
        }

        dispatch(
          actionGetDataByFilter(
            parseInt(defaultAxe.iddatasource),
            indicator?.indicateurs.map((item) => item.id),
            indicator.idindicator,
            {
              name: defaultAxe.name,
              class:
                parseInt(defaultAxe.dataType) === 3 ? "time" : "dimensions",
            },
            filters,
            (status, result) => {
              if (status === 200) {
                try {
                  if (result) {
                    const listsNew = [...listsRef.current];
                    for (let a = 0; a < listsNew.length; a++) {
                      const list = listsNew[a];
                      for (let b = 0; b < list.indicators.length; b++) {
                        const indicator = list.indicators[b];
                        if (parseInt(indicator.idindicator) === id) {
                          listsNew[a].indicators[b]["isLoading"] = false;
                          listsNew[a].indicators[b]["is"] = true;
                          listsNew[a].indicators[b]["data"] = result;
                          break;
                        }
                      }
                    }

                    dispatch(
                      actionSetLists({ type: "ALL", data: [...listsNew] })
                    );
                  }
                } catch (error) {
                  // console.log("error", error);
                }
              }
            }
          )
        );
      }
    }
  };

  const getNewData = (ididatasource) => {
    for (let i = 0; i < listsRef?.current.length; i++) {
      const list = listsRef.current[i];
      for (let j = 0; j < list.indicators.length; j++) {
        const indicator = list.indicators[j];
        const id = parseInt(indicator.idindicator);
        let filter = null;
        let defaultAxe = null;
        let emailAxe = null;

        if (indicator.idEmailColumn && indicator.showByEmail) {
          for (let index = 0; index < indicator.columns.length; index++) {
            const column = indicator.columns[index];

            if (+column.idcolumn == +indicator.idEmailColumn) {
              emailAxe = column;
              break;
            }
          }
        }

        for (let index = 0; index < indicator.columns.length; index++) {
          const column = indicator.columns[index];
          if (column.idcolumn == indicator.idfilter) {
            filter = column;
            break;
          }
        }

        if (indicator.iddefault) {
          for (let index = 0; index < indicator.columns.length; index++) {
            const column = indicator.columns[index];
            if (column.idcolumn == indicator.iddefault) {
              defaultAxe = column;
              break;
            }
          }
        } else {
          defaultAxe = { ...filter };
        }

        const filters = [
          {
            name: filter.name,
            type: 3,
            class: "time",
            interval: [
              new Date(new Date(intervalRef.current[0]).setHours(21, 0, 0, 0))
                .toISOString()
                .split(".")[0],
              new Date(new Date(intervalRef.current[1]).setHours(21, 0, 0, 0))
                .toISOString()
                .split(".")[0],
            ],
          },
        ];

        if (emailAxe) {
          filters.push({
            name: emailAxe.name,
            type: 2,
            class: "dimensions",
            values: [userEmail],
          });
        }
        if (+defaultAxe.iddatasource === +ididatasource) {
          dispatch(
            actionGetDataByFilter(
              parseInt(defaultAxe.iddatasource),
              indicator?.indicateurs.map((item) => item.id),
              indicator.idindicator,
              {
                name: defaultAxe.name,
                class:
                  parseInt(defaultAxe.dataType) === 3 ? "time" : "dimensions",
              },
              filters,
              (status, result) => {
                if (status === 200) {
                  try {
                    if (result) {
                      const listsNew = [...listsRef.current];
                      for (let a = 0; a < listsNew.length; a++) {
                        const list = listsNew[a];
                        for (let b = 0; b < list.indicators.length; b++) {
                          const indicator = list.indicators[b];
                          if (parseInt(indicator.idindicator) === id) {
                            listsNew[a].indicators[b]["isLoading"] = false;
                            listsNew[a].indicators[b]["is"] = true;
                            listsNew[a].indicators[b]["data"] = result;
                            break;
                          }
                        }
                      }

                      dispatch(
                        actionSetLists({ type: "UPDATE", data: [...listsNew] })
                      );
                    }
                  } catch (error) {
                    // console.log("error", error);
                  }
                }
              }
            )
          );
        }
      }
    }
  };

  const onChangeDate = (interval, value, period = null) => {
    // console.log("idperiod", period);
    setValue(value);
    setInterval(interval);
    dispatch(actionSetTime(interval));
    dispatch(actionSetTimeValue(value));
    if (interval[0] && interval[1]) {
      dispatch(
        actionSetIndicatorData({
          interval: interval,
        })
      );
      dispatch(
        actionChangeTime(
          board.iddashboard,
          idUser,
          value,
          new Date(interval[0]).toISOString().split(".")[0],
          new Date(interval[1]).toISOString().split(".")[0],
          period,
          token,
          () => {}
        )
      );
      let newLists = [...listsRef.current];
      for (let i = 0; i < newLists.length; i++) {
        const list = newLists[i];
        for (let j = 0; j < list.indicators.length; j++) {
          newLists[i].indicators[j].isLoading = true;
        }
      }
      dispatch(actionSetLists({ type: "ALL", data: [...newLists] }));
      setTimeout(() => {
        defaultData();
      }, 100);
    }
  };

  const showUpdate = (list) => {
    setSelectedList(list);
    setVisibility(false);
    setLabel(list?.name);
    setReadOnly(list?.readonly);
    setUpdateVisibility(true);
  };
  console.log(idUser);

  const addList = (e) => {
    e.preventDefault();
    if (label) {
      dispatch(
        actionAddList(
          label,
          readonly,
          idUser,
          board.iddashboard,
          token,
          (status) => {
            if (status === 200) {
              setLabel("");
              setReadOnly(false);
              enqueueSnackbar("Une section a été ajoutée", {
                variant: "success",
              });
            } else {
              enqueueSnackbar("La section n'a pas été ajoutée !", {
                variant: "warning",
              });
            }
          }
        )
      );
    } else {
      enqueueSnackbar("Le nom est obligatoire.", {
        variant: "warning",
      });
    }
  };

  const confirmDeleteList = () => {
    if (selectedList?.idlist) {
      dispatch(
        actionDeleteList(selectedList.idlist, token, (status) => {
          if (status) {
            setDeleteVisible(false);
            setSelectedList(null);
            setVisibility(true);
            enqueueSnackbar("La section a bien été supprimé", {
              variant: "success",
            });
          } else {
            enqueueSnackbar("Une erreur est survenue.", {
              variant: "error",
            });
          }
        })
      );
    }
  };

  const onDelete = (list) => {
    setListVisibility(false);
    setSelectedList(list);
    setDeleteVisible(true);
  };

  const cancelUpdate = () => {
    setSelectedList(null);
    setUpdateVisibility(false);
    setLabel("");
    setReadOnly(false);
    setListVisibility(true);
  };

  const onUpdate = (e) => {
    e.preventDefault();
    if (label && selectedList) {
      dispatch(
        actionUpdateList(
          label,
          readonly,
          selectedList.idlist,
          selectedList.positionx,
          selectedList.positiony,
          token,
          (status) => {
            if (status) {
              cancelUpdate();
            } else {
              enqueueSnackbar("Une erreur est survenue", {
                variant: "error",
              });
            }
          }
        )
      );
    } else {
      enqueueSnackbar("Le nom est obligatoire.", {
        variant: "warning",
      });
    }
  };

  const setLists = (data) => {
    dispatch(actionSetLists({ type: "ALL", data }));
    dispatch(
      actionMoveLists(
        data.map((item, index) => {
          return { id: item.idlist, positionx: index };
        }),
        token
      )
    );
  };

  const cancel = () => {
    handleCancel();
    setRules([]);
    setSelectedLists([]);
    setVisibility(false);
    setIndicatorName("");
    setShowCumul(false);
    setSource(null);
    setMetrics(null);
    setAxeDate(null);
    setAxes(null);
    setType(null);
    setAxeEmail(null);
    setShowByEmail(false);
    setOptionsAxeEmail([]);
    setDefaultAxe(null);
    setDescription("");
    setSourceName("");
    setData_operation({
      value: 1,
      label: "Remplacer les données.",
    });
    setRefresh({ value: false, label: "Manuel" });
    setPeriod({ value: 0, label: "Heure" });
    setFrequence(1);
    setSymbole("");
    setSize("1");
    setRadioRegroupeDefault("1");
    setShowRadioRegroupe(false);
    setShowLastValue(false);
  };

  useEffect(() => {
    setFrequence(1);
    setSourceName("");
    setData_operation({
      value: 1,
      label: "Remplacer les données.",
    });
    setPeriod({ value: 0, label: "Heure" });
    if (data?.callback) {
      setIsAsync(true);
    } else {
      setIsAsync(false);
    }
    if (data?.url || data?.callback) {
      setRefresh({ value: true, label: "Automatique" });
    } else {
      setRefresh({ value: false, label: "Manuel" });
    }
  }, [sourceVisibility, data]);

  useEffect(() => {
    if (!sourceVisibility) {
      setData();
    }
  }, [sourceVisibility]);

  useEffect(() => {
    if (sourceRef.current) {
      const filters = [];
      const datasource = datasourcesRef.current[sourceRef.current.value];
      const columns = datasource.columns.filter((item) => +item.dataType !== 3);

      for (let i = 0; i < columns.length; i++) {
        const column = columns[i];

        filters.push({
          id: column.idcolumn,
          name: column.name,
          type: parseInt(column.dataType),
          checked: false,
          indicator: Boolean(column.columnType === "indicator"),
          min: null,
          max: null,
          loading: parseInt(column.dataType) === 2 ? true : false,
          value: null,
          values: [],
          options: [],
          interval: [null, null],
        });

        setFilters([...filters]);
        // setOptionIndicators(indi);
        dispatch(
          actionGetConditionByDdataSource(
            datasource.iddatasource,
            token,
            (status) => {}
          )
        );
        dispatch(
          actionGetIndicatorsByDataSource(
            datasource.iddatasource,
            token,
            (status) => {}
          )
        );

        // if (parseInt(column.dataType) === 2) {
        //   dispatch(
        //     actionGetOptions(
        //       column.iddatasource,
        //       column.name,
        //       (status, result) => {
        //         if (status === 200) {
        //           let alpha = [...filtersRef.current];
        //           for (let j = 0; j < alpha.length; j++) {
        //             const item = alpha[j];
        //             if (parseInt(item.id) === parseInt(column.idcolumn)) {
        //               alpha[j]["options"] = result;
        //               alpha[j]["loading"] = false;
        //               setFilters([...alpha]);
        //             }
        //           }
        //         }
        //       }
        //     )
        //   );
        // }
      }
    } else {
      setFilters([]);
    }
  }, [metrics, axeDate, axeEmail, axes, source]);

  useEffect(() => {
    if (sourceRef.current) {
      const datasource = datasourcesRef.current[sourceRef.current.value];
      // console.log(datasource.iddatasource);
      const data = localStorage.getItem("data");
      if (datasource.iddatasource) {
        dispatch(
          actionGetConditionByDdataSource(
            datasource.iddatasource,
            "Bearer " + JSON.parse(data).token,
            (status) => {}
          )
        );
      }
    }
  }, [source, datasources]);

  const cancelSource = () => {
    setVisibility(true);
    setSourceVisibility(false);
    setSourceName("");
    setRefresh({ value: false, label: "Manuel" });
    setPeriod({ value: 0, label: "Heure" });
    setFrequence(1);
  };

  const showIframe = (e) => {
    e.preventDefault();
    setIframeVisibility(true);
    setVisibility(false);
  };

  const cancelIframe = () => {
    setIframeVisibility(false);
    setVisibility(true);
  };

  const submit = (e) => {
    e.preventDefault();
    try {
      const datasource = datasourcesRef.current[sourceRef.current.value];

      if (!name) throw new Error("le nom de l'indicateur est l'obligatoire");
      else if (!source)
        throw new Error("la source de données  est l'obligatoire");
      else if (!type)
        throw new Error("le type de graphe de graphe est obligatoire");
      else if (indicateurs.length == 0)
        throw new Error("sélectionnez aumoins un indicateur");
    } catch (e) {
      enqueueSnackbar(e.message, {
        variant: "warning",
      });
    }

    if (
      indicatorNameRef.current &&
      selectedLists.length > 0 &&
      sourceRef.current &&
      Array.isArray(indicateurs) &&
      indicateurs.length > 0 &&
      axeDateRef.current &&
      typeRef.current &&
      axesRef.current &&
      defaultAxeRef.current
    ) {
      const description = descriptionRef.current;
      const name = indicatorNameRef.current;
      const type = typeRef.current.value;
      const datasource = datasourcesRef.current[sourceRef.current.value];

      // const metrics = [];

      // for (let i = 0; i < metricsRef.current.length; i++) {
      //   const metric = metricsRef.current[i];
      //   const column = datasource.columns[metric.value];
      //   metrics.push(column);
      // }

      const axeDefault = datasource.columns[defaultAxeRef.current.value];

      const axeEmail = axeEmailRef.current
        ? datasource.columns[axeEmailRef.current.value]
        : null;
      const axeDate = datasource.columns[axeDateRef.current.value];
      const axes = [];

      const filters = filtersRef.current.filter((item) => item.checked);

      for (let i = 0; i < filters.length; i++) {
        const filter = filters[i];
        if (
          (filter.type === 1 || filter.type === 4) &&
          !filter.max &&
          !filter.min
        ) {
          enqueueSnackbar(`Le filtre ${filter.name} n'est pas renseigné`, {
            variant: "warning",
          });
          return;
        } else if (filter.type === 2 && !filter.values.length > 0) {
          enqueueSnackbar(`Le filtre ${filter.name} n'est pas renseigné`, {
            variant: "warning",
          });
          return;
        }
      }

      if (!(parseInt(axeDefault.dataType) === 3 && parseInt(type) === 2)) {
        for (let i = 0; i < axesRef.current.length; i++) {
          const element = axesRef.current[i];
          if (parseInt(element.value) !== parseInt(axeDateRef.current.value)) {
            axes.push(parseInt(datasource.columns[element.value].idcolumn));
          }
        }
        dispatch(
          actionAddIndicator(
            idUser,
            [...selectedLists.map((item) => item.value)],
            indicateurs.map((metric) => +metric.value),
            parseInt(axeDate.idcolumn),
            parseInt(axeDefault.idcolumn),
            axeEmail ? parseInt(axeEmail.idcolumn) : null,
            [
              ...axes,
              parseInt(axeDate.idcolumn),
              ...(axeEmail ? [parseInt(axeEmail.idcolumn)] : []),
            ],
            filters,
            name,
            description,
            type,
            token,
            operationRef.current.value,
            symboleRef.current,
            sizeRef.current,
            showCumul,
            notShowCumulWithGoal,
            showRadioRegroupeRef.current,
            showLastValue,
            showByEmail,
            radioRegroupeDefaultRef.current,
            rules,
            (status, indicator) => {
              if (status) {
                // const filters = [
                //   {
                //     name: axeDate.name,
                //     type: 3,
                //     class: "time",
                //     interval: [
                //       new Date(
                //         new Date(intervalRef.current[0]).setHours(21, 0, 0, 0)
                //       )
                //         .toISOString()
                //         .split(".")[0],
                //       new Date(
                //         new Date(intervalRef.current[1]).setHours(21, 0, 0, 0)
                //       )
                //         .toISOString()
                //         .split(".")[0],
                //       ,
                //     ],
                //   },
                // ];
                // if (axeEmail) {
                //   filters.push({
                //     name: axeEmail.name,
                //     type: 2,
                //     class: "dimensions",
                //     values: [userEmail],
                //   });
                // }
                // dispatch(
                //   actionGetDataByFilter(
                //     +axeDefault.iddatasource,
                //     metrics.map((metric) => metric.name),
                //     indicator.idindicator,
                //     {
                //       name: axeDefault.name,
                //       class:
                //         parseInt(axeDefault.dataType) === 3
                //           ? "time"
                //           : "dimensions",
                //     },
                //     filters,
                //     (status, result) => {
                //       if (status === 200) {
                //         if (result) {
                //           indicator["isLoading"] = false;
                //           indicator["is"] = true;
                //           indicator["data"] = result;
                //           const newLists = [...listsRef.current];

                //           for (let i = 0; i < selectedLists.length; i++) {
                //             const id = selectedLists[i].value;
                //             for (let k = 0; k < newLists.length; k++) {
                //               const list = newLists[k];
                //               if (+list.idlist === +id) {
                //                 newLists[k].indicators.push(indicator);
                //                 break;
                //               }
                //             }
                //           }

                //           dispatch(
                //             actionSetLists({
                //               type: "ALL",
                //               data: [...newLists],
                //             })
                //           );

                //           setVisibility(false);
                //           cancel();
                //           enqueueSnackbar("L'indicateur a été ajouté", {
                //             variant: "success",
                //           });
                //         }
                //       }
                //     }
                //   )
                // );
                // defaultData();
                enqueueSnackbar("L'indicateur a  été ajouté !", {
                  variant: "success",
                });
                window.location.reload();
              } else {
                enqueueSnackbar("L'indicateur n'a pas été ajouté !", {
                  variant: "warning",
                });
              }
            }
          )
        );
      } else {
        enqueueSnackbar(
          "Un graph de type Pie ne peut avoir pour axe par défaut une date.",
          {
            variant: "warning",
          }
        );
      }
    } else {
      enqueueSnackbar("Veuillez entrer tous les champs obligatoires", {
        variant: "warning",
      });
    }
  };

  const handlerChangeDatasource = (data) => {
    setSource(data);
    const { value } = data;
    if (isInteger(parseInt(value))) {
      const index = parseInt(value);
      const src = datasources[index];
      let axesLanda = [];
      let axesEmail = [];
      let metricsLanda = [];
      let timesLanda = [];

      for (let i = 0; i < src.columns.length; i++) {
        const column = src.columns[i];
        if (column.columnType === "indicator") {
          metricsLanda.push({ value: i, label: column.name });
        } else {
          axesLanda.push({ value: i, label: column.name });
        }
        if (parseInt(column.dataType) === 2) {
          axesEmail.push({ value: i, label: column.name });
        }
        if (parseInt(column.dataType) === 3) {
          timesLanda.push({ value: i, label: column.name });
        }
      }

      setOptionsAxe(axesLanda);
      setOptionsAxeEmail(axesEmail);
      setOptionsMetric(metricsLanda);
      setOptionsAxeDate(timesLanda);

      setAxes(null);
      setMetrics(null);
      setAxeDate(null);
      setDefaultAxe(null);
      setAxeEmail(null);

      if (timesLanda.length === 1) {
        setAxeDate(timesLanda[0]);
      }

      if (metricsLanda.length === 1) {
        setMetrics(metricsLanda[0]);
      }
    }
  };

  const onWheel = (event) => {
    const parents = document.getElementsByClassName("custom-scroll-bar-list");
    const modals = document.getElementsByClassName("parent-modal-closable");
    let test = true;
    for (let i = 0; i < modals.length; i++) {
      const parent = modals[i];
      if (parent.contains(event.target) || parent === event.target) {
        return;
      }
    }
    for (let i = 0; i < parents.length; i++) {
      const parent = parents[i];
      if (parent.contains(event.target) || parent === event.target) {
        if (parent.scrollHeight > parent.clientHeight) {
          test = false;
        }
        break;
      }
    }
    if (event.deltaY !== -0 && test) {
      if (document.getElementById("trello")) {
        document.getElementById("trello").scrollLeft += event.deltaY;
      }
    }
  };
  const customStylesVue = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "#F3F5F8", // bg-red-600
      border: "none",
      boxShadow: "none",
      outline: "none",
      padding: "0",
      fontWeight: "500",
      fontFamily: "Poppins",
      fontSize: "16 px", // tailwind equivalent of small font
      minHeight: "20px",
      minWidth: "130px",
      cursor: "pointer",
      padding: 0,
      margin: 0,
    }),
    option: (provided, state) => ({
      ...provided,
      padding: "5px",
      fontSize: "12px",
      fontWeight: "500",
      fontFamily: "Poppins", // tailwind equivalent of small font
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      // color: "#ffffff", fontWeight: "bold",
      fontFamily: "Poppins",
      fontSize: "15px", // tailwind equivalent of small font
    }),
    singleValue: (provided) => ({
      ...provided,
      // color: "#ffffff", // text color inside the select fontWeight: "bold",
      fontFamily: "Poppins",
      fontSize: "15px", // tailwind equivalent of small font
    }),
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: " #fff", // bg-red-600
      border: "none",
      boxShadow: "none",
      outline: "none",
      padding: "0",
      fontWeight: "600",
      fontFamily: "Poppins",
      fontSize: "18px", // tailwind equivalent of small font
      minHeight: "auto",
      minWidth: "150px",
      cursor: "pointer",
      padding: 0,
      margin: 0,
      marginTop: 10,
    }),
    option: (provided, state) => ({
      ...provided,
      padding: "5px",
      fontSize: "12px",
      fontWeight: "600",
      fontFamily: "Poppins", // tailwind equivalent of small font
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      // color: "#ffffff", fontWeight: "bold",
      fontFamily: "Poppins",
      fontSize: "18px", // tailwind equivalent of small font
    }),
    singleValue: (provided) => ({
      ...provided,
      // color: "#ffffff", // text color inside the select fontWeight: "bold",
      fontFamily: "Poppins",
      fontSize: "18px", // tailwind equivalent of small font
    }),
  };

  const customStylesV1 = {
    control: (provided) => ({
      ...provided,
      width: "200px",
      borderRadius: "20px",
      border: "2px solid #e0e0e0",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "10px",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#4285F4" : "white",
      color: state.isSelected ? "white" : "black",
    }),
  };

  useEffect(() => {
    if (lists.length > 0) {
      const response = lists.filter((item) => +item.idlist === +idlist);
      if (response.length === 0) {
        setIdlist({ value: +lists[0].idlist, label: lists[0].name });
      }
    }
  }, [lists]);
  const handleChangeFilter = (selectedOptions) => {
    setSelectedTypes(selectedOptions);
  };

  return (
    <>
      <Modal
        visible={modifParam}
        title={"Gestion des membres"}
        onCancel={() => setModifParam(false)}
        width={600}
      >
        {board && board.teamDashboards?.length > 0 ? (
          <div className="wrap-table">
            <table className="display responsive">
              <tbody
                axis="y"
                lockAxis="y"
                useDragHandle
                disableAutoscroll
                helperClass="row-dragging"
              >
                <tr>
                  <td className="table-style">Equipe(s)</td>
                  <td className="table-style">
                    <ul className="actions">
                      <li>Admin</li>
                      <li> {""}</li>
                    </ul>
                  </td>
                </tr>
                {board && board.teamDashboards
                  ? board.teamDashboards.map(
                      ({
                        team,
                        idteam,
                        role,
                        iddashboard,
                        teamDashboardLists,
                        idteamdashboard,
                      }) => {
                        return (
                          <Member
                            name={team.name}
                            token={token}
                            isTeam={true}
                            isViewOnly={isViewOnly}
                            lists={teamDashboardLists?.map(({ list }) => list)}
                            idMember={idteamdashboard}
                            id={`${idteam}`}
                            role={role}
                            update={(value) => {
                              dispatch(
                                actionSetTeamRoleDashboard(
                                  iddashboard,
                                  idteam,
                                  value === true ? "ADMIN" : "VIEW",
                                  token,
                                  () => {}
                                )
                              );
                            }}
                            remove={() => {
                              dispatch(
                                removeTeamDashboard(
                                  iddashboard,
                                  idteam,
                                  token,

                                  () => {
                                    enqueueSnackbar(
                                      `${team.name} a été retirer de la dashboard`,
                                      {
                                        variant: "success",
                                      }
                                    );
                                  }
                                )
                              );
                            }}
                          />
                        );
                      }
                    )
                  : null}
              </tbody>
            </table>
          </div>
        ) : (
          <p style={{ padding: 40, textAlign: "center" }}>
            Aucune Equipe n'est présente
          </p>
        )}
        {board && board?.userDashboards?.length > 0 ? (
          <div className="wrap-table" style={{ marginTop: 40 }}>
            <table className="display responsive">
              <tbody
                axis="y"
                lockAxis="y"
                useDragHandle
                disableAutoscroll
                helperClass="row-dragging"
              >
                <tr>
                  <td className="table-style">Membre(s)</td>
                  <td className="table-style">
                    <ul className="actions">
                      <li>Admin</li>
                      <li> {""}</li>
                    </ul>
                  </td>
                </tr>

                {board && board.userDashboards
                  ? board.userDashboards.map(
                      ({
                        user,
                        role,
                        iduser,
                        iddashboard,
                        userDashboardLists,
                        iduserdashboard,
                      }) => {
                        return (
                          <Member
                            name={user.email}
                            token={token}
                            isTeam={false}
                            isViewOnly={isViewOnly}
                            id={`${iduser}`}
                            key={`${iduser}`}
                            lists={userDashboardLists?.map(({ list }) => list)}
                            idMember={iduserdashboard}
                            role={role}
                            update={(value) => {
                              dispatch(
                                actionSetUserRoleDashboard(
                                  iddashboard,
                                  iduser,
                                  value === true ? "ADMIN" : "VIEW",
                                  token,
                                  () => {}
                                )
                              );
                            }}
                            remove={() => {
                              dispatch(
                                removeUserDashboard(
                                  iddashboard,
                                  iduser,
                                  token,
                                  () => {
                                    enqueueSnackbar(
                                      `${user.email} a été retirer de la dashboard`,
                                      {
                                        variant: "success",
                                      }
                                    );
                                  }
                                )
                              );
                            }}
                          />
                        );
                      }
                    )
                  : null}
              </tbody>
            </table>
          </div>
        ) : (
          <p style={{ padding: 40, textAlign: "center" }}>
            Aucun membre n'est présent
          </p>
        )}
        <button
          onClick={() => {
            setModifParam(false);
            setModalSharedVisibility(true);
          }}
          title="Partager"
          className="mt-3 btn-border"
        >
          <i className="fa-solid fa-users"></i> Partager
        </button>
      </Modal>
      <Modal
        visible={deleteVisibility}
        title={"Confirmer la suppression"}
        onCancel={isDeleteBoard ? null : () => setDeleteVisibility(false)}
      >
        <div className="row">
          <div className="col-md-12 wrap-btn-modal">
            <div className="btn-container">
              <button
                className="btn-border close-btn-submit"
                type="reset"
                onClick={
                  isDeleteBoard ? null : () => setDeleteVisibility(false)
                }
              >
                Annuler
              </button>
              <button
                className="btn-full"
                type="submit"
                disabled={isDeleteBoard}
                onClick={() => {
                  dispatch(
                    actionDeleteDashboard(board.iddashboard, token, (is) => {
                      if (is) {
                        sessionStorage.removeItem("dashboard");
                        navigate("/home");
                        setDeleteVisibility(false);
                      }
                    })
                  );
                }}
              >
                {isDeleteBoard ? "Supprimer..." : "Supprimer"}
              </button>
            </div>
          </div>
        </div>
      </Modal>
      <ModalAddSource
        visibility={iframeVisibility}
        onCancel={cancelIframe}
        url={url}
        id={idconnector}
        setId={setIdConnector}
        setUrl={setUrl}
        onReceive={(json, total, id) => {
          if (sourceName) {
            dispatch(
              actionAddDatasource(
                idUser,
                id,
                {
                  name: sourceName,
                  url: json.url,
                  rows: json.rows,
                  columns: json.columns,
                },
                token,
                (status, datasource) => {
                  if (status === 200) {
                    dispatch(
                      actionSetDataDatasources({
                        id: datasource.iddatasource,
                        total: total,
                        visibilityProgress: true,
                        count: 0,
                      })
                    );
                    setSourceVisibility(false);
                    setIframeVisibility(false);
                    setVisibility(true);
                    setSourceName("");
                  }
                }
              )
            );
          }
        }}
      />
      <Modal
        visible={sourceVisibility}
        title={"Ajouter une source de donnée"}
        onCancel={cancelSource}
      >
        <form onSubmit={onAdd}>
          <div className="row">
            <div className="col-md-12">
              <div className="input-container">
                <label for="nom" className="label-default">
                  Entrer le nom de la source de donnée
                </label>
                <span className="span-block">
                  <input
                    className="input-default inputCustom"
                    name="nom"
                    id="nom"
                    type="text"
                    value={sourceName}
                    onChange={(e) => setSourceName(e.target.value)}
                    placeholder="Obligatoire"
                    required
                  />
                </span>
                {(data?.url || data?.callback) && (
                  <>
                    <br />
                    <label className="label-default">
                      Type de rafraichissement
                    </label>
                    <CustomSelect
                      id="refresh"
                      value={refresh}
                      style={{ textSize: "5px" }}
                      options={[
                        { value: false, label: "Manuel" },
                        { value: true, label: "Automatique" },
                      ]}
                      onChange={setRefresh}
                    />
                    <br />
                    <label className="label-default">
                      Frequence et Periode de rafraichissement
                    </label>
                    <div className="row">
                      <div className="col-3 col-md-3">
                        <input
                          className="input-default inputCustom"
                          disabled={!refresh.value}
                          type="number"
                          value={frequence}
                          min={1}
                          style={{ textAlign: "center" }}
                          onChange={(e) => {
                            if (
                              parseInt(e.target.value) > 0 ||
                              e.target.value === ""
                            ) {
                              setFrequence(e.target.value);
                            }
                          }}
                        />
                      </div>
                      <div className="col-9 col-md-9">
                        <CustomSelect
                          status={!refresh.value}
                          id="period"
                          value={period}
                          style={{ textSize: "5px", height: "20px" }}
                          options={[
                            { value: 0, label: "Heure" },
                            { value: 1, label: "Jour" },
                            { value: 2, label: "Semaine" },
                            { value: 3, label: "Mois" },
                            { value: 4, label: "Année" },
                          ]}
                          onChange={setPeriod}
                        />
                      </div>
                    </div>
                  </>
                )}
                <br />
                <label className="label-default">
                  Opération à réalisé lors du rafraichissement
                </label>
                <Alert severity="info">
                  {data_operation.value === 1 ? (
                    <>
                      Lors du <strong>rafraichissement</strong> toutes les
                      données seront remplacées par les nouvelles données.
                    </>
                  ) : data_operation.value === 2 ? (
                    <>
                      Lors du <strong>rafraichissement</strong> les nouvelles
                      données seront ajoutées aux anciennes données.
                    </>
                  ) : (
                    <>
                      Lors du <strong>rafraichissement</strong> les nouvelles
                      données seront ajoutées aux anciennes données avec{" "}
                      <strong>possibilité de modifier un élement</strong>{" "}
                      nécessite <strong>un identifiant unique</strong>.
                    </>
                  )}
                </Alert>
                <br />
                <CustomSelect
                  value={data_operation}
                  style={{ textSize: "5px" }}
                  options={operationOptions}
                  onChange={setData_operation}
                />
                {data_operation.value === 3 && (
                  <>
                    <br />
                    <label className="label-default">Indentifiant unique</label>
                    <Alert severity="warning">
                      Après insertion{" "}
                      <strong>cette valeur ne poura plus être modifiée</strong>.
                    </Alert>
                    <br />
                    <CustomSelect
                      isMulti
                      value={externalIds}
                      style={{ textSize: "5px" }}
                      options={
                        data?.columns
                          ? data.columns.map((item) => {
                              return { value: item.index, label: item.name };
                            })
                          : []
                      }
                      onChange={setExternalIds}
                    />
                  </>
                )}
                {data?.callback && (
                  <>
                    <br />
                    <span
                      className="span-block h-custom-options"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "left",
                      }}
                    >
                      <Checkbox
                        checked={isAsync}
                        onClick={() => {
                          setIsAsync(!isAsync);
                        }}
                      >
                        <span>
                          Insertion asynchrone (Pour des données volumineuses)
                        </span>
                      </Checkbox>
                    </span>
                  </>
                )}

                <br />
              </div>
            </div>
            <div className="col-md-12 wrap-btn-modal">
              <div className="btn-container">
                <button
                  className="btn-border close-btn-submit"
                  type="reset"
                  onClick={cancelSource}
                >
                  Retour
                </button>
                <button className="btn-full" type="submit">
                  Continuer
                </button>
              </div>
            </div>
          </div>
        </form>
      </Modal>

      <Modal
        visible={visibility}
        title={"Ajouter une vue"}
        onCancel={isAddIndicator ? null : cancel}
        large={true}
        width={750}
      >
        <form onSubmit={submit}>
          <div className="flex flex-col w-full h-full gap-1 p-0 m-0">
            <div className="flex flex-col gap-2">
              <label for="nom" className="font-poppins font-[400px]">
                Entrer le nom de la vue *
              </label>

              <input
                className="w-full p-2 border-2 rounded-md outline-none border-inputBorderColor hover:outline-none active:outline-none"
                id="nom"
                type="text"
                value={indicatorName}
                onChange={(e) => setIndicatorName(e.target.value)}
                placeholder="Obligatoire"
              />
            </div>

            <div className="flex flex-col gap-2">
              <label for="datasource" className="font-poppins font-[400px]">
                Sélectionner la source de données *
              </label>

              <CustomSelect
                id="datasource"
                value={source}
                options={optionsDatasources}
                onChange={handlerChangeDatasource}
              />
            </div>
            <div className="flex flex-col flex-1 gap-2">
              <label className="font-poppins font-[400px]">
                Sélectionner le type graphe *
              </label>
              <span className="">
                <CustomSelect
                  id="type"
                  value={type}
                  options={GRAPH_TYPES}
                  onChange={setType}
                />
              </span>
            </div>
            <div className="flex justify-between gap-3">
              <div className="flex flex-col flex-1 gap-2">
                <label for="metric" className="font-poppins font-[400px]">
                  Sélectionner indicateur(s) *
                </label>

                <CustomSelect
                  id="metric"
                  isMulti
                  value={indicateurs}
                  options={indicateurData.map((item) => ({
                    value: item.id,
                    label: item.name,
                    key: item.id,
                  }))}
                  onChange={setIndicateurs}
                />
              </div>
              <div className="flex flex-col flex-1 gap-2">
                <label
                  for="default-axe-date"
                  className="font-poppins font-[400px]"
                >
                  Sélectionner l'axe date par défaut *
                </label>
                <span className="">
                  <CustomSelect
                    id=""
                    value={axeDate}
                    options={optionsAxeDate}
                    onChange={setAxeDate}
                  />
                </span>
              </div>
            </div>

            <div className="flex justify-between gap-3">
              <div className="flex flex-col flex-1 gap-2">
                <label for="axes" className="font-poppins font-[400px]">
                  Sélectionner axe d'analyse *
                </label>

                <CustomSelect
                  id="axes"
                  isMulti
                  value={axes}
                  options={optionsAxe}
                  onChange={(data) => {
                    setAxes(data);
                    setDefaultAxe(null);
                  }}
                />
              </div>
              <div className="flex flex-col flex-1 gap-2">
                <label for="default-axe" className="font-poppins font-[400px]">
                  Sélectionner l'axe d'analyse par défault *
                </label>

                <CustomSelect
                  id="default-axe"
                  value={defaultAxe}
                  options={axes}
                  onChange={(data) => {
                    setDefaultAxe(data);
                    if (axes && data) {
                      if (axes[data.value]?.dataType !== "3") {
                        setShowRadioRegroupe(false);
                      }
                    }
                  }}
                />
              </div>
            </div>

            <div className="flex justify-between gap-3">
              {board?.type === 2 && (
                <div className="flex flex-col flex-1 gap-2 w-[50%]">
                  <label className="font-poppins font-[400px]">
                    Sélectionner vues *
                  </label>

                  <CustomSelect
                    isMulti
                    value={selectedLists}
                    options={lists.map((item) => {
                      return { value: item.idlist, label: item.name };
                    })}
                    onChange={setSelectedLists}
                  />
                </div>
              )}
              <div className="flex flex-col gap-2 w-[50%]">
                <label for="axe-email" className="font-poppins font-[400px]">
                  Sélectionner l'axe email
                </label>

                <CustomSelect
                  id="axe-email"
                  isClearable
                  value={axeEmail}
                  options={optionsAxeEmail}
                  onChange={setAxeEmail}
                />
              </div>
            </div>

            <div className="mt-2">
              <h4 className="font-poppins font-[400px]">Options d'affichage</h4>
              <div className="flex items-start justify-between w-full h-full">
                <div className="flex-1">
                  <RadioButton
                    onChange={(value) => {}}
                    defaultValue={"1"}
                    value={size}
                    setValue={setSize}
                    options={[
                      { label: "Miniature", value: "0" },
                      { label: "Normal", value: "1" },
                      { label: "En évidence", value: "2" },
                    ]}
                  />
                </div>

                <div className="flex-1 ml-[93px]">
                  <div className="">
                    {axeEmail && (
                      <div className="">
                        <Checkbox
                          id="show-by-email"
                          checked={showByEmail}
                          onClick={() => {
                            setShowByEmail(!showByEmail);
                          }}
                        >
                          <span className="font-poppins font-[300px]">
                            Afficher donnée par email
                          </span>
                        </Checkbox>
                      </div>
                    )}
                    {/* <div className="">
                      <Checkbox
                        id="show-cumul"
                        checked={showCumul}
                        onClick={() => {
                          setShowCumul(!showCumul);
                        }}
                      >
                        <span className="font-poppins font-[300px]">
                          Afficher courbe de cumul
                        </span>
                      </Checkbox>
                    </div>
                    <div className="">
                      <Checkbox
                        id="not-show-cumul-with-goal"
                        checked={notShowCumulWithGoal}
                        onClick={() => {
                          setNotShowCumulWithGoal(!notShowCumulWithGoal);
                        }}
                      >
                        <span className="font-poppins font-[300px]">
                          Ne pas afficher cumul avec l'objectif
                        </span>
                      </Checkbox>
                    </div>
                    <div className="">
                      <Checkbox
                        id="idShowLastValue"
                        checked={showLastValue}
                        onClick={() => {
                          setShowLastValue(!showLastValue);
                        }}
                      >
                        <span className="font-poppins font-[300px]">
                          Afficher valeur précédente
                        </span>
                      </Checkbox>
                    </div>
                    <div
                      className=""
                      hidden={(() => {
                        if (sourceRef.current && defaultAxeRef.current) {
                          const datasource =
                            datasourcesRef.current[sourceRef.current.value];
                          const axeDefault =
                            datasource.columns[defaultAxeRef.current.value];
                          return axeDefault.dataType !== "3";
                        }
                      })()}
                    >
                      <Checkbox
                        checked={showRadioRegroupe}
                        onClick={() => {
                          setShowRadioRegroupe(!showRadioRegroupe);
                        }}
                        style={{ marginBottom: "10px" }}
                      >
                        <span className="font-poppins font-[300px]">
                          Afficher periode
                        </span>
                      </Checkbox>
                      {showRadioRegroupe && (
                        <RadioButton
                          defaultValue={"1"}
                          value={radioRegroupeDefault}
                          hidden={!showRadioRegroupe}
                          setValue={setRadioRegroupeDefault}
                          options={[
                            { label: "Jour", value: "1" },
                            { label: "Semaine", value: "4" },
                            { label: "Mois", value: "2" },
                            { label: "Année", value: "3" },
                          ]}
                        />
                      )}
                    </div> */}
                  </div>
                </div>
              </div>
            </div>

            <div className="flex items-center justify-center w-full gap-3 mt-2">
              <span
                className="btn-border close-btn-submit font-poppins font-[400px]"
                type="reset"
                onClick={isAddIndicator ? null : cancel}
              >
                Annuler
              </span>
              <button
                type={"submit"}
                className="btn-full font-poppins font-[400px]"
                disabled={isAddIndicator}
              >
                {isAddIndicator ? "+ Ajouter..." : "+ Ajouter"}
              </button>
            </div>
          </div>
        </form>
      </Modal>

      <ModalShared
        visibility={modalSharedVisibility}
        dashboard={board}
        onCancel={cancelShared}
        token={token}
        isViewOnly={isViewOnly}
      />
      <Modal
        visible={listVisibility}
        title={"Gestion des sections"}
        onCancel={() => (isAddList ? null : setListVisibility(false))}
        width={650}
      >
        <form onSubmit={addList}>
          <div className="row">
            <div className="col-md-12">
              <div className="input-container">
                <label for="nom" className="label-default">
                  Entrer le nom
                </label>
                <span className="span-block">
                  <input
                    className="input-default inputCustom"
                    name="nom"
                    id="nom"
                    type="text"
                    value={label}
                    onChange={(e) => setLabel(e.target.value)}
                    placeholder="Obligatoire"
                    required
                  />
                </span>
              </div>
              <div
                className="input-container"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginLeft: 2,
                }}
              >
                <label for="readonly" className="label-default">
                  <Checkbox
                    id="readonly"
                    checked={readonly}
                    onChange={(e) => {
                      setReadOnly(e.target.checked);
                    }}
                  >
                    {" "}
                    Visible en lecture seul
                  </Checkbox>
                </label>
              </div>
            </div>
            <div className="col-md-12 wrap-btn-modal">
              <div className="btn-container">
                <button className="btn-full" type="submit" disabled={isAddList}>
                  {isAddList ? "Ajouter..." : "Ajouter"}
                </button>
              </div>
            </div>
          </div>
        </form>
        <br />
        <ViewContainer
          items={lists}
          setItems={setLists}
          onDelete={onDelete}
          onUpdate={showUpdate}
        />
      </Modal>

      <Modal
        visible={deleteVisible}
        title={`Confirmer la suppression de la vue "${selectedList?.name}"`}
        onCancel={
          isDelete
            ? null
            : () => {
                setDeleteVisible(false);
                setVisibility(true);
              }
        }
      >
        <div className="row">
          <div className="col-md-12 wrap-btn-modal">
            <div className="btn-container">
              <button
                className="btn-border close-btn-submit"
                type="reset"
                disabled={isDelete}
                onClick={isDelete ? null : () => setDeleteVisible(false)}
              >
                Annuler
              </button>
              <button
                className="btn-full"
                type="submit"
                disabled={isDelete}
                onClick={
                  isDelete
                    ? null
                    : () => {
                        confirmDeleteList();
                      }
                }
              >
                {isDelete ? "Confirmer..." : "Confirmer"}
              </button>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        visible={updateVisibility}
        title={"Modifier une vue"}
        onCancel={isUpdate ? null : cancelUpdate}
      >
        <form onSubmit={onUpdate}>
          <div className="row">
            <div className="col-md-12">
              <div className="input-container">
                <label for="nom" className="label-default">
                  Entrer le nom
                </label>
                <span className="span-block">
                  <input
                    className="input-default inputCustom"
                    name="nom"
                    id="nom"
                    type="text"
                    value={label}
                    onChange={(e) => setLabel(e.target.value)}
                    placeholder="Obligatoire"
                    required
                  />
                </span>
              </div>
              <div
                className="input-container"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginLeft: 2,
                }}
              >
                <label for="readonly" className="label-default">
                  <Checkbox
                    id="readonly"
                    checked={readonly}
                    onChange={(e) => {
                      setReadOnly(e.target.checked);
                    }}
                  >
                    {" "}
                    Visible en lecture seul
                  </Checkbox>
                </label>
              </div>
            </div>
            <div className="col-md-12 wrap-btn-modal">
              <div className="btn-container">
                <button className="btn-full" type="submit" disabled={isUpdate}>
                  {isUpdate ? "Modifier..." : "Modifier"}
                </button>
              </div>
            </div>
          </div>
        </form>
      </Modal>
      <Snackbar
        open={visibilityProgress}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Paper
          elevation={3}
          style={{
            width: "200px",
            height: "75px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-evenly",
            backgroundColor: "#323541",
            color: "#fff",
          }}
        >
          <CircularProgress
            variant={pourcent === 0 ? "indeterminate" : "determinate"}
            value={pourcent}
            size={25}
          />
          Extration...
        </Paper>
      </Snackbar>
      <Header />

      <main onWheel={onWheel}>
        <div
          className="container-fluid mt-[60px] "
          id="viabber-board-container"
        >
          <div className="bg-white w-full h-[95px] row actions-nav m-3 mx-auto border-r-black rounded-[5px] flex-col items-center gap-2">
            <div className="flex items-center justify-between w-full gap-2 px-4 pr-6 h-[40px] font-poppins ">
              <Select
                id="refresh"
                value={
                  board
                    ? { value: board?.iddashboard, label: board?.name }
                    : {
                        value: selectedDashboard?.iddashboard,
                        label: selectedDashboard?.name,
                      }
                }
                styles={customStyles}
                options={dashboards.map((item) => ({
                  value: item.iddashboard,
                  label: item.name,
                }))}
                onChange={(val) => {
                  const dashboard = dashboards.find(
                    (item) => item.iddashboard === val.value
                  );

                  // navigate("/board");
                  sessionStorage.setItem(
                    "dashboard",
                    JSON.stringify(dashboard)
                  );
                  setSelectedDashboard(dashboard);
                }}
              />

              <div className="flex items-center gap-2">
                {/* <svg
                  width="23"
                  height="23"
                  viewBox="0 0 26 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.5625 25.5L9.0625 21.5C8.79167 21.3958 8.53646 21.2708 8.29688 21.125C8.05729 20.9792 7.82292 20.8229 7.59375 20.6562L3.875 22.2188L0.4375 16.2812L3.65625 13.8438C3.63542 13.6979 3.625 13.5573 3.625 13.4219V12.5781C3.625 12.4427 3.63542 12.3021 3.65625 12.1562L0.4375 9.71875L3.875 3.78125L7.59375 5.34375C7.82292 5.17708 8.0625 5.02083 8.3125 4.875C8.5625 4.72917 8.8125 4.60417 9.0625 4.5L9.5625 0.5H16.4375L16.9375 4.5C17.2083 4.60417 17.4635 4.72917 17.7031 4.875C17.9427 5.02083 18.1771 5.17708 18.4062 5.34375L22.125 3.78125L25.5625 9.71875L22.3438 12.1562C22.3646 12.3021 22.375 12.4427 22.375 12.5781V13.4219C22.375 13.5573 22.3542 13.6979 22.3125 13.8438L25.5312 16.2812L22.0938 22.2188L18.4062 20.6562C18.1771 20.8229 17.9375 20.9792 17.6875 21.125C17.4375 21.2708 17.1875 21.3958 16.9375 21.5L16.4375 25.5H9.5625ZM11.75 23H14.2188L14.6562 19.6875C15.3021 19.5208 15.901 19.276 16.4531 18.9531C17.0052 18.6302 17.5104 18.2396 17.9688 17.7812L21.0625 19.0625L22.2812 16.9375L19.5938 14.9062C19.6979 14.6146 19.7708 14.3073 19.8125 13.9844C19.8542 13.6615 19.875 13.3333 19.875 13C19.875 12.6667 19.8542 12.3385 19.8125 12.0156C19.7708 11.6927 19.6979 11.3854 19.5938 11.0938L22.2812 9.0625L21.0625 6.9375L17.9688 8.25C17.5104 7.77083 17.0052 7.36979 16.4531 7.04688C15.901 6.72396 15.3021 6.47917 14.6562 6.3125L14.25 3H11.7812L11.3438 6.3125C10.6979 6.47917 10.099 6.72396 9.54688 7.04688C8.99479 7.36979 8.48958 7.76042 8.03125 8.21875L4.9375 6.9375L3.71875 9.0625L6.40625 11.0625C6.30208 11.375 6.22917 11.6875 6.1875 12C6.14583 12.3125 6.125 12.6458 6.125 13C6.125 13.3333 6.14583 13.6562 6.1875 13.9688C6.22917 14.2812 6.30208 14.5938 6.40625 14.9062L3.71875 16.9375L4.9375 19.0625L8.03125 17.75C8.48958 18.2292 8.99479 18.6302 9.54688 18.9531C10.099 19.276 10.6979 19.5208 11.3438 19.6875L11.75 23ZM13.0625 17.375C14.2708 17.375 15.3021 16.9479 16.1562 16.0938C17.0104 15.2396 17.4375 14.2083 17.4375 13C17.4375 11.7917 17.0104 10.7604 16.1562 9.90625C15.3021 9.05208 14.2708 8.625 13.0625 8.625C11.8333 8.625 10.7969 9.05208 9.95312 9.90625C9.10938 10.7604 8.6875 11.7917 8.6875 13C8.6875 14.2083 9.10938 15.2396 9.95312 16.0938C10.7969 16.9479 11.8333 17.375 13.0625 17.375Z"
                    fill="#54555E"
                  />
                </svg> */}
                <i
                  aria-describedby={tag}
                  className="fa-light fa-ellipsis more"
                  style={{
                    color:
                      theme === "0"
                        ? "#fff"
                        : theme === "1"
                        ? "#1f2128"
                        : "#1f2128",
                  }}
                  onClick={handleClick}
                ></i>
              </div>
              <Popover
                id={tag}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "center",
                  horizontal: "left",
                }}
              >
                <div className="mui-popover-custom">
                  <ul>
                    {iscapable || (idUser && !isViewOnly) ? (
                      <>
                        {/* <li>
                          <a
                            href="#"
                            title="Modifier"
                            className="mui-popover-item"
                            onClick={update}
                          >
                            Modifier
                          </a>
                        </li> */}
                        <li>
                          <a
                            href="#"
                            onClick={() => {
                              setAnchorEl(null);
                              setModalSharedVisibility(true);
                            }}
                            title="Inviter à rejoindre"
                            className="mui-popover-item"
                          >
                            Inviter à rejoindre
                          </a>
                        </li>
                        <li>
                          <a
                            href="#"
                            onClick={() => setModifParam(true)}
                            title="Gérer les membres"
                            className="mui-popover-item"
                          >
                            Gérer les membres
                          </a>
                        </li>
                        <li>
                          <a
                            href="#"
                            title="Supprimer"
                            className="mui-popover-item"
                            onClick={() => {
                              setAnchorEl(null);
                              setDeleteVisibility(true);
                            }}
                          >
                            Supprimer
                          </a>
                        </li>
                      </>
                    ) : (
                      <li>
                        <a
                          href="#"
                          onClick={() => {
                            setAnchorEl(null);
                            setModalSharedVisibility(true);
                          }}
                          title="Inviter à rejoindre"
                          className="mui-popover-item"
                        >
                          Inviter à rejoindre
                        </a>
                      </li>
                    )}
                  </ul>
                </div>
              </Popover>
            </div>

            <div className="w-full h-[40px] flex items-center justify-between px-6 gap-2 font-poppins ">
              <div className="flex items-center justify-center gap-3">
                <div className="flex items-center gap-2 text-[12px] m-0 p-0 justify-center">
                  <p className="mt-[12px] font-medium text-center">
                    Sélectionner une section
                  </p>
                  <Select
                    id="refresh"
                    className="z-50"
                    value={idlist}
                    styles={customStylesVue}
                    options={lists?.map((item) => ({
                      value: item.idlist,
                      label: item.name,
                    }))}
                    onChange={setIdlist}
                  />
                  {/* {!isViewOnly && (
                    <p
                      onClick={() => {
                        setListVisibility(true);
                      }}
                      className="p-2 m-0 btn-full"
                      type="button"
                    >
                      Gestion des sections
                    </p>
                  )} */}
                </div>
                {/* <div className="flex items-center gap-2 text-[12px] m-0 p-0 justify-center z-50">
                  <FiFilter className="text-xl text-gray-500" />
                  <p className="mt-[12px] font-medium text-center">
                    Filtrer par type d'indicateur
                  </p>
                  <Select
                    isMulti
                    options={GRAPH_TYPES}
                    value={selectedTypes}
                    onChange={handleChangeFilter}
                    styles={customStylesVue}
                    placeholder="Sélectionner les types"
                  />
                </div> */}
              </div>
              <div className="flex items-center gap-2 p-0 m-0">
                <CalendarView
                  value={value}
                  interval={interval}
                  period={idperiod}
                  onPeriodChange={(value) => {
                    setIdPeriod(value);
                  }}
                  onChange={(interval, value, period) => {
                    onChangeDate(interval, value, period);
                  }}
                  class="myColor2"
                  selectStyle={{
                    width: 150,
                  }}
                  calendarStyle={{
                    width: 250,
                  }}
                />
              </div>
              <div className="flex items-center gap-2">
                {((idUser && !isViewOnly) || iscapable) && (
                  <p
                    className="hover:text-white hover:bg-colorText border-2 border-colorText text-colorText  rounded-[20px] p-0 m-0 text-center font-poppins py-1 w-[180px] font-semibold cursor-pointer text-[12px]"
                    onClick={() => {
                      setVisibility(true);
                    }}
                  >
                    + Ajouter une vue
                  </p>
                )}

                {/* <svg
                  width="25"
                  height="25"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20 10V6.25H10V10H7.5V3.75H22.5V10H20ZM22.5 15.625C22.8542 15.625 23.151 15.5052 23.3906 15.2656C23.6302 15.026 23.75 14.7292 23.75 14.375C23.75 14.0208 23.6302 13.724 23.3906 13.4844C23.151 13.2448 22.8542 13.125 22.5 13.125C22.1458 13.125 21.849 13.2448 21.6094 13.4844C21.3698 13.724 21.25 14.0208 21.25 14.375C21.25 14.7292 21.3698 15.026 21.6094 15.2656C21.849 15.5052 22.1458 15.625 22.5 15.625ZM20 23.75V18.75H10V23.75H20ZM22.5 26.25H7.5V21.25H2.5V13.75C2.5 12.6875 2.86458 11.7969 3.59375 11.0781C4.32292 10.3594 5.20833 10 6.25 10H23.75C24.8125 10 25.7031 10.3594 26.4219 11.0781C27.1406 11.7969 27.5 12.6875 27.5 13.75V21.25H22.5V26.25ZM25 18.75V13.75C25 13.3958 24.8802 13.099 24.6406 12.8594C24.401 12.6198 24.1042 12.5 23.75 12.5H6.25C5.89583 12.5 5.59896 12.6198 5.35938 12.8594C5.11979 13.099 5 13.3958 5 13.75V18.75H7.5V16.25H22.5V18.75H25Z"
                    fill="#54555E"
                  />
                </svg> */}
              </div>
            </div>
          </div>
        </div>
        {board?.type === 1 || !Boolean(board?.type) ? (
          <TrelloDashboard
            isViewOnly={isViewOnly || !idUser}
            lists={lists}
            onAddIndicator={setVisibility}
            setIdList={setIdlist}
            trelloY={trelloY}
          />
        ) : (
          <SimpleDashboard
            isViewOnly={!idUser || (!iscapable && isViewOnly)}
            height={simpleY}
            screenX={screenX}
            idlist={idlist.value}
            setIdList={setIdlist}
            onAddIndicator={setVisibility}
            lists={lists}
          />
        )}
      </main>
    </>
  );
}
